import { Link } from '@mui/material';
import { COLORS } from '../dashboards/shared';

/** Nome do posto como link para a tela do posto (nova aba). */
const PlaceLink = ({ placeId, label }: { placeId: string; label: string }) => (
  <Link href={`#/places/${placeId}/show`} target="_blank" rel="noopener" underline="always" sx={{ fontWeight: 700, fontSize: 15, color: COLORS.ink }}>
    {label}
  </Link>
);

export default PlaceLink;
